import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { find, orderBy, uniqBy } from "lodash";
import { useEffect, useState } from "react";
import Ativo from "../../models/ativo";

export default function ProcurarAtivo({
  codigoAtivo: codigoAtivo,
  onChange,
}: {
  codigoAtivo: string | undefined;
  onChange: (value: Ativo | undefined) => void;
}) {
  const [ativos, setAtivos] = useState<Ativo[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAtivos = async () => {
      setLoading(true);
      try {
        const url = `https://us-central1-${process.env.FIREBASE_PROJECT_ID}.cloudfunctions.net/front-listarAtivos`;
        console.log("Tentando acessar URL:", url);

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
        });

        if (!response.ok) {
          throw new Error(`Erro na requisição: ${response.status}`);
        }

        const data = await response.json();
        const ativosConvertidos = data.ativos.map((ativo: any) =>
          Ativo.conversorAtivo(ativo)
        );
        setAtivos(ativosConvertidos);
      } catch (error) {
        console.error("Erro ao buscar ativos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAtivos();
  }, []);

  const ativo = find(ativos, (a) => a.codigoAtivo === codigoAtivo);
  return (
    <Autocomplete
      id="search-ativo"
      freeSolo
      autoHighlight
      options={orderBy(
        uniqBy(ativos, (a) => a.isin),
        ["classeAtivo", "codigoAtivo"]
      )}
      getOptionLabel={(option) => {
        if (typeof option === "object")
          return `${option.codigoAtivo} - ${option.razaoSocial}`;
        else return option.toUpperCase();
      }}
      defaultValue={ativo}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Encontre mais ativos"
          fullWidth
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && (
                  <Typography variant="labelMono" color="text.secondary">
                    Carregando...
                  </Typography>
                )}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      // Ticker é código: mono tabular à esquerda, razão social em corpo.
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          key={option.isin || option.codigoAtivo}
          sx={{ display: "flex", gap: 1.5, alignItems: "baseline" }}
        >
          <Typography
            variant="dataMono"
            color="text.primary"
            sx={{ minWidth: 72, fontWeight: 500 }}
          >
            {option.codigoAtivo}
          </Typography>
          <Typography variant="body2" color="text.secondary" noWrap>
            {option.razaoSocial}
          </Typography>
        </Box>
      )}
      groupBy={(ativo) => ativo.classeAtivo}
      slotProps={{
        paper: {
          sx: (theme) => ({
            "& .MuiAutocomplete-groupLabel": {
              ...theme.typography.labelMono,
              color: theme.palette.text.secondary,
              backgroundColor: theme.palette.background.paper,
              borderBottom: `1px solid ${theme.palette.divider}`,
              lineHeight: 2.6,
            },
          }),
        },
      }}
      onChange={(_, value) => {
        if (!!!value) {
          onChange(undefined);
        } else if (typeof value === "object") onChange(value);
        else onChange({ codigoAtivo: value.toUpperCase() } as Ativo);
      }}
      sx={{ my: 1 }}
    />
  );
}
